/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyAddressViewModel } from "../types/AssociatedCompanyAddressViewModel.ts";

export const associatedCompanyAddressViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  countryId: z.optional(z.number().int()),
  stateId: z.number().int().nullish(),
  cityId: z.number().int().nullish(),
  stateName: z.string().nullish(),
  cityName: z.string().nullish(),
  zipCode: z.string().nullish(),
  postCode: z.string().nullish(),
  street: z.string().nullish(),
  placeNumber: z.string().nullish(),
  neighborhood: z.string().nullish(),
  complement: z.string().nullish(),
}) as unknown as ToZod<AssociatedCompanyAddressViewModel>;
